// extracted by mini-css-extract-plugin
export default {"formItem":"formItem-bpQ_xk","container":"container-X5E2go","icon":"icon-CPe2Ol","hint":"hint-oArZBS","success":"success-VvDhDY","left":"left-HKQI59","tips":"tips-Eor1_N"};